import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule, NgIf, NgStyle } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IgxGridModule } from '@infragistics/igniteui-angular';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { DialogConfirmDeleteComponent } from 'src/app/core/dialog/dialog-confirm-parker-delete/dialog-confirm-delete.component';
import { AuthService } from 'src/app/core/services/auth-security/auth.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';
import { IAdditionalEmails, IParkerProfileDetail } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-parkers-v2-additional-emails',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    NgIf,
    IgxGridModule,
    MatButtonModule,
    ClipboardModule,
  ],
  templateUrl: './parkers-v2-additional-emails.component.html',
  styleUrl: './parkers-v2-additional-emails.component.scss',
})
export class ParkersV2AdditionalEmailsComponent implements OnInit, AfterViewInit {
  @Input() parkerDetail: IParkerProfileDetail;

  additionalEmails: IAdditionalEmails[] = [];
  parker: IParkerProfileDetail = {} as IParkerProfileDetail;
  emailEditForm: FormGroup;
  additionalEmailSaveMode: boolean = false;
  gridFontSize: number = 12;
  parkerId: string;
  currentEmailEditIndex: number = -1;
  currentlyActiveRow: number = -1;
  updateEmailMode: boolean = false;
  emailEditAdditionalEmailId: number = 0;
  emailNewForm: FormGroup;

  public options = {
    enabled: true,
    copyHeaders: true,
    copyFormatters: true,
    separator: '\t',
  };
  clipboard: any;

  //Services
  _appGeneralState = inject(AppGeneralStateService);

  constructor(
    private dataService: DataService,
    private parkerStateService: ParkerStateService,
    private snackBarService: MatSnackBar,
    private authService: AuthService,
    public dialog: MatDialog,
    private _cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    // this.parker = this.parkerStateService.getParkerDetail();
    this.parkerId = this.parkerDetail.parkerId;

    //this.parkerDetail = this.parkerStateService.getParkerDetail();

    this.initEmailEditForm();

    this.initEmailNewForm();

    this.getAllAdditionalEmailsForParker(this.parkerDetail.parkerId);
  }

  public ngAfterViewInit(): void {
    this._cdr.detectChanges();
  }

  initEmailNewForm(): void {
    try {
      this.emailNewForm = new FormGroup({
        additionalEmailAddress: new FormControl('', [Validators.required, Validators.email]),
        additionalEmailName: new FormControl('', []),
        additionalEmailTitle: new FormControl('', []),
        additionalEmailComments: new FormControl('', []),
      });
    } catch (err) {
      console.error('Error on init vehicle edit form ' + JSON.stringify(err));
    }
  }

  public onKeyDown(keyDown: KeyboardEvent): void {
    if (keyDown.code == 'Space') keyDown.stopPropagation();
  }

  initEmailEditForm(): void {
    try {
      this.emailEditForm = new FormGroup({
        additionalEditEmailAddress: new FormControl('', [
          Validators.required,
          Validators.email,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ]),
        additionalEditEmailName: new FormControl('', []),
        additionalEditEmailTitle: new FormControl('', []),
        additionalEditEmailComments: new FormControl('', []),
      });
    } catch (err) {
      console.error('Error on init vehicle edit form ' + JSON.stringify(err));
    }
  }

  onSubmitAddNewEmailAddress(): void {
    let newEmail: IAdditionalEmails = {} as IAdditionalEmails;

    newEmail.parkerId = this.parkerDetail.parkerId;
    newEmail.emailAddress = this.emailNewForm.get('additionalEmailAddress')!.value;
    newEmail.name = this.emailNewForm.get('additionalEmailName')!.value;
    newEmail.title = this.emailNewForm.get('additionalEmailTitle')!.value;
    newEmail.comments = this.emailNewForm.get('additionalEmailComments')!.value;
    newEmail.userName = this._appGeneralState.userName;
    newEmail.additionalEmailId = 0;
    newEmail.dateEntered = new Date();
    newEmail.lotNumber = this.parkerDetail.lotNumber;

    this.postAdditionalEmail(newEmail);
  }

  postAdditionalEmail(emailData: IAdditionalEmails) {
    let additionalEmailId: number;

    this.dataService.postAdditionalEmailforParker(emailData).subscribe(
      (res) => {
        additionalEmailId = res;
      },
      (err: any) => {},
      () => {
        let snackBarMessage: string = '';
        if (additionalEmailId === -2) {
          snackBarMessage = 'This email address already exists for this parker.';
        }

        if (additionalEmailId === -1) {
          snackBarMessage = 'An unknown error occurred adding this email address.  Please try again.';
        }

        if (additionalEmailId > -1) {
          // 20240806 :: Ken Moss.  Missing snackbar message on initial code
          snackBarMessage = 'This email address has been added successfully.';

          // 20240806 :: Ken Moss.  Changed updating to grid from appending new email to existing array, to getting list from db again.
          this.getAllAdditionalEmailsForParker(this.parkerDetail.parkerId);

          this.parkerStateService.parkerNumberAdditionalEmails = this.additionalEmails.length;

          this.emailNewForm.patchValue({
            additionalEmailAddress: '',
            additionalEmailName: '',
            additionalEmailTitle: '',
            additionalEmailComments: '',
          });
        }

        let action: any;
        this.snackBarService.open(snackBarMessage, action, {
          duration: 3000,
        });
      },
    );
  }

  updateAccessHolder(): void {}

  onResetAdditionalEmailData(): void {
    this.initEmailEditForm();
  }

  onResetAdditionalEmailNewForm(): void {
    this.emailNewForm.patchValue({
      additionalEmailAddress: '',
      additionalEmailName: '',
      additionalEmailTitle: '',
      additionalEmailComments: '',
    });
  }

  getQSRRowBackgroundColor(rowNumber: number): string {
    if (this.currentlyActiveRow === rowNumber) {
      return 'yellow';
    } else {
      if (rowNumber % 2 === 1) return '#e1e1e4';
      else return '#fff';
    }
  }

  getAllAdditionalEmailsForParker(parkerId: string): void {
    this.dataService.getAdditionalEmailsForParker(parkerId).subscribe(
      (res) => {
        this.additionalEmails = res;
      },
      (err: any) => {},
      () => {
        this.parkerStateService.parkerNumberAdditionalEmails = this.additionalEmails.length;
      },
    );
  }

  onDeleteEmail(additionalEmailId: number): void {
    const dialogRef = this.dialog.open(DialogConfirmDeleteComponent);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.deleteAdditionalEmail(additionalEmailId);
    });
  }

  onSubmitUpdateEmailAddress(): void {
    let updatedEmail: IAdditionalEmails = {} as IAdditionalEmails;

    updatedEmail.additionalEmailId = this.emailEditAdditionalEmailId;
    updatedEmail.userName = this._appGeneralState.userName;
    updatedEmail.lotNumber = this.parkerDetail.lotNumber;
    updatedEmail.parkerId = this.parkerDetail.parkerId;
    updatedEmail.emailAddress = this.emailEditForm.get('additionalEditEmailAddress')!.value;
    updatedEmail.name = this.emailEditForm.get('additionalEditEmailName')!.value;
    updatedEmail.title = this.emailEditForm.get('additionalEditEmailTitle')!.value;
    updatedEmail.comments = this.emailEditForm.get('additionalEditEmailComments')!.value;

    this.updateAdditionalEmail(updatedEmail);
  }

  onEnableEmailEditMode(additionalEmailId: number): void {
    this.additionalEmailSaveMode = true;
    this.updateEmailMode = true;

    const additionalEditEmailAddress = this.additionalEmails.find(
      (email) => email.additionalEmailId == additionalEmailId,
    );

    this.initEmailEditForm();

    this.emailEditForm.patchValue({
      additionalEditEmailAddress: additionalEditEmailAddress.emailAddress,
      additionalEditEmailName: additionalEditEmailAddress.name,
      additionalEditEmailTitle: additionalEditEmailAddress.title,
      additionalEditEmailComments: additionalEditEmailAddress.comments,
    });
  }

  onEnableCancelEmailEditMode(): void {
    this.additionalEmailSaveMode = false;
    this.currentEmailEditIndex = -1;
    this.updateEmailMode = false;

    this.onResetAdditionalEmailData();
  }

  deleteAdditionalEmail(additionalEmailId: number) {
    let status: boolean;
    this.dataService.deleteAdditionalEmailforParker(additionalEmailId).subscribe(
      (res) => {
        status = res;
      },
      (err: any) => {},
      () => {
        let action: any;
        this.snackBarService.open('The Email Address has been successfully deleted.', action, {
          duration: 3000,
        });

        this.currentEmailEditIndex = -1;
        this.additionalEmailSaveMode = false;

        const index = this.additionalEmails.findIndex((index) => index.additionalEmailId == additionalEmailId);
        if (index != -1) {
          this.additionalEmails.splice(index, 1);
          this.parkerStateService.parkerNumberAdditionalEmails = this.additionalEmails.length;
        }
      },
    );
  }

  updateAdditionalEmail(emailData: IAdditionalEmails) {
    let status: boolean;
    this.dataService.updateAdditionalEmailforParker(emailData).subscribe(
      (res) => {
        status = res;
      },
      (err: any) => {},
      () => {
        let action: any;
        this.snackBarService.open('The Email Address has been successfully updated.', action, {
          duration: 3000,
        });

        //update existing email data structure
        let ii: number = 0;

        for (ii = 0; ii < this.additionalEmails.length; ii++) {
          if (emailData.additionalEmailId === this.additionalEmails[ii].additionalEmailId) {
            this.additionalEmails[ii].name = emailData.name;
            this.additionalEmails[ii].userName = emailData.userName;
            this.additionalEmails[ii].emailAddress = emailData.emailAddress;
            this.additionalEmails[ii].comments = emailData.comments;
            this.additionalEmails[ii].title = emailData.title;
          }
        }

        this.currentEmailEditIndex = -1;
        this.additionalEmailSaveMode = false;
        this.updateEmailMode = false;

        //this.initEmailEditForm();
        this.onResetAdditionalEmailData();
      },
    );
  }

  onnCopyContactEmailToClipboard(emailAddress: string): void {
    this.clipboard.copy(emailAddress);
    this.snackBarService.open('Email Address Name copied to clipboard', '', { duration: 3000 });
  }

  onCopyMessage(message: string): void {
    this.snackBarService.open(message, '', { duration: 3000 });
  }
}
